import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/payment.css";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

const planRates = {
  Basic: 7500,
  Standard: 12000,
  Premium: 18000,
};

const installRates = {
  Motorcycle: 3000,
  Tricycle: 3000,
  Car: 7000,
  Bus: 7000,
  Truck: 10000,
  Others: 5000,
};

const discountMap = {
  "3 Months": 0.05,
  "6 Months": 0.10,
  "12 Months": 0.15,
};

const PaymentPage = () => {
  const { state } = useLocation();
  const { form, regId } = state || {};
  const navigate = useNavigate();

  if (!form) return <p>No registration data. Please return to register.</p>;

  const months = parseInt(form.billingFrequency);
  const planCost = planRates[form.plan] || 0;
  const vehicleCount = form.vehicles.length;
  const discount = discountMap[form.billingFrequency] || 0;

  const baseSub = planCost * months * vehicleCount;
  const discountAmount = baseSub * discount;
  const finalSub = baseSub - discountAmount;

  const installFee = form.vehicles.reduce((acc, v) => {
    const type = v.type || "Others";
    return acc + (installRates[type] || installRates["Others"]);
  }, 0);

  const total = finalSub + installFee;

  const handlePayNow = () => {
    console.log("PaymentPage.js - Initiating Paystack payment...");
    console.log("PaymentPage.js - Total amount (NGN):", total);
    const amountInKobo = total * 100;
    console.log("PaymentPage.js - Amount in kobo:", amountInKobo);
    console.log("PaymentPage.js - Email:", form.email);

    const handler = window.PaystackPop.setup({
      key: "pk_test_b4138f5df6aae2702f4b8f1d42f844cc6a050760", // Replace with your Paystack Test Public Key
      email: form.email,
      amount: amountInKobo,
      currency: "NGN",
      metadata: {
        name: form.name,
        plan: form.plan,
        vehicle_count: vehicleCount,
        reg_id: regId, // Include registration ID for reference
      },
      callback: (response) => {
        console.log("PaymentPage.js - Paystack callback triggered:", response);
        toast.success("Payment successful! Reference: " + response.reference);
        navigate("/dashboard");
      },
      onClose: () => {
        console.log("PaymentPage.js - Paystack payment window closed");
        toast.info("Payment window closed.");
      },
    });

    handler.openIframe();
  };

  const handlePayLater = () => {
    console.log("PaymentPage.js - Sending Pay Later email...");
    const paystackLink = "https://paystack.com/pay/track-" + Date.now();
    const emailData = {
      to_name: form.name,
      to_email: form.email,
      plan: form.plan,
      amount: `₦${total.toLocaleString()}`,
      pay_link: paystackLink,
    };

    emailjs
      .send(
        "service_prrpmyo",
        "template_v0zsuhj",
        emailData,
        "Tcn9gnDE2wHYDcjIy"
      )
      .then(() => {
        alert("✅ Payment link has been sent to your email!");
      })
      .catch((err) => {
        console.error("❌ Email failed", err);
        alert("Something went wrong while sending the email.");
      });
    navigate("/");
  };

  return (
    <div className="payment-container">
      <h2>📦 Registration Summary</h2>

      <div className="summary">
        <p><strong>Name:</strong> {form.name}</p>
        <p><strong>Email:</strong> {form.email}</p>
        <p><strong>Plan:</strong> {form.plan}</p>
        <p><strong>Billing Period:</strong> {form.billingFrequency}</p>
        <p><strong>Vehicles:</strong> {vehicleCount}</p>
      </div>

      <div className="cost-breakdown">
        <h3>💰 Cost Breakdown</h3>
        <p>Subscription Fee: ₦{baseSub.toLocaleString()}</p>
        <p>Discount ({discount * 100}%): -₦{discountAmount.toLocaleString()}</p>
        <p>Installation Fee: ₦{installFee.toLocaleString()}</p>
        <hr />
        <h2>Total: ₦{total.toLocaleString()}</h2>
      </div>

      <div className="payment-actions">
        <button onClick={handlePayNow} className="pay-now">💳 Pay Now</button>
        <button onClick={handlePayLater} className="pay-later">📨 Pay Later</button>
      </div>
    </div>
  );
};

export default PaymentPage;